import { addResizeObserver, FiltersMap } from '@wix/bex-core';
import { action, makeObservable } from 'mobx';
import { ToolbarCollectionState } from '../../state';

export class ToolbarState<T, F extends FiltersMap> {
  readonly toolbar;

  constructor(toolbar: ToolbarCollectionState<T, F>) {
    this.toolbar = toolbar;

    makeObservable(this, {
      init: action,
    });
  }

  _subscribeResizeOrMoved({
    scrollElement,
  }: {
    readonly scrollElement?: HTMLElement | null;
  }) {
    const { toolbar: table } = this;

    if (scrollElement == null) {
      return;
    }

    const onResizedOrMoved = action(function onResizedOrMoved() {
      const scrollElementRect = scrollElement.getBoundingClientRect();
      table.scrollElementRect.height = scrollElementRect.height;
      table.scrollElementRect.top = scrollElementRect.top;
    });

    const onResizedOrMovedThrottled = table.container.lodash.throttle(
      () => requestAnimationFrame(onResizedOrMoved),
      300,
    );

    const onScroll = () => {
      onResizedOrMovedThrottled();
    };

    scrollElement.addEventListener('scroll', onScroll);

    const dispose = addResizeObserver(scrollElement, onResizedOrMovedThrottled);

    const onResizedOrMovedAnimationFrame = requestAnimationFrame(() => {
      requestAnimationFrame(onResizedOrMoved);
    });

    return () => {
      dispose?.();
      cancelAnimationFrame(onResizedOrMovedAnimationFrame);
      scrollElement.removeEventListener('scroll', onScroll);
    };
  }

  init({ scrollElement }: { scrollElement?: HTMLElement | null }) {
    const disposers = [
      this.toolbar.toolbarRect.init({ scrollElement }),
      this._subscribeResizeOrMoved({ scrollElement }),
    ];

    return () => {
      disposers.forEach((d) => d?.());
    };
  }
}
